import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	const { blockID, content, level, typography, backgroundColor } = attributes;
	const { fontFamily } = typography || {};
	const blockProps = useBlockProps.save( {
		className: `block-${ blockID }`,
		'x-data': 'heading',
		'data-font-families': [ fontFamily ],
	} );

	const tagName = level || 'p';

	return (
		<>
			<RichText.Content
				{ ...blockProps }
				tagName={ tagName }
				value={ content }
			/>
		</>
	);
}
